module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptertitle"
  }, [_c('a', {
    attrs: {
      "id": "p6"
    }
  }), _vm._v(" Dena Sheets's Fiery Breakfast Burritos")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Here is another pack 'em in your saddlebag and ride breakfast treat. After you work up an appetite riding in the morning air, you can enjoy these at a scenic rest area. This recipe is from Dena Sheets, a Harley lady from Lead, South Dakota, who tells us, \"These burritos are great to fix in the morning, go for a putt, and chow down in about an hour. Wrap them in tin foil, put them in the saddlebags, and eat in about an hour or two.\"")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("pounds pork roast, cooked in the slow cooker the night before (see Note)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("12")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("10-inch flour tortillas")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("12")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("large eggs, scrambled")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("4-ounce cans diced green chiles, drained")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("4-ounce cans diced jalapeños, drained")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("12")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("ounces cheddar cheese, shredded")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Salsa")])])])]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Heat the shredded pork in a small amount of water till very hot. Heat the tortillas one at a time in the microwave according to the package directions.")]), _vm._v(" "), _c('li', [_vm._v("Place some shredded pork, eggs, chiles, jalapeños, cheese, and salsa on each tortilla. Fold up and wrap in tin foil to keep warm or serve immediately.")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("MAKES")]), _vm._v(" 12 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("BURRITOS")])])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("NOTE")])]), _vm._v(" Cook the pork with 2 teaspoons ground cumin, 2 tablespoons chopped garlic, 2 teaspoons chili powder, and salt and black pepper to taste. Once it's fork tender, shred the pork and refrigerate till morning.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269ca73a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c004.vue
// module id = 90
// module chunks = 0